import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button'
import { useNavigate } from 'react-router-dom'
import Imagen from '../imagen/Imagen.jsx'
import { InputConTextoSugerencia } from '../reutilizables/inputConTextoSugerencia/InputConTextoSugerencia.jsx'
import Precios from '../reutilizables/precios/Precios'
import { SumarProductos } from '../reutilizables/sumarProductos/SumarProductos.jsx'
import * as carritoService from './../servicios/carritoService'
import styles from './CarritoItem.module.css'

const CarritoItem = (props) => {
  const { centroDeCostos } = props
  const [cantidad, setCantidad] = useState(props.item.cantidad)
  const cantDisponible = props.item.cantDisponible
  const [sugerencias, setSugerencias] = useState([])
  const [sugerenciasImputacion, setSugerenciasImputacion] = useState([])
  const [sugerenciasCodMat, setSugerenciasCodMat] = useState([])

  const sumar = () => {
    if (cantidad < cantDisponible) {
      setCantidad(cantidad + 1)
      props.sumar(props.totalSuma + props.item.precioUnitario)
    }
  }

  const restar = () => {
    if (cantidad > 1) {
      setCantidad(cantidad - 1)
      props.sumar(props.totalSuma - props.item.precioUnitario)
    }
  }

  const navigate = useNavigate()

  useEffect(() => {
    const carrito = {
      idPublicacion: props.item.idPublicacion,
      idUsuario: parseInt(localStorage.getItem('idUsuario')),
      cantidad: cantidad,
      idEstado: 1
    }
    const actualizarCarrito = async (carrito) => {
      await carritoService.actualizar(carrito)
    }
    actualizarCarrito(carrito)
    props.setItems((prevItems) =>
      prevItems.map((item) =>
        item.idPublicacion === carrito.idPublicacion
          ? { ...item, cantidad: carrito.cantidad }
          : item
      )
    )
    props.setTotalSuma(props.totalSuma + props.item.valorTotalConIva)
  }, [cantidad])

  const handleSelectSugerencias = (descripcion, propiedad) => {
    props.modificarCarrito(descripcion.descripcion, propiedad, props.item.idPublicacion)
    setSugerencias([])
    setSugerenciasImputacion([])
    setSugerenciasCodMat([])
  }

  const handleChange = (texto, propiedad, setSugerencias, array) => {
    props.modificarCarrito(texto, propiedad, props.item.idPublicacion)
    setSugerencias(
      texto.trim() === ''
        ? []
        : array.filter(
            (opcion) =>
              opcion.codigo?.includes(texto) || opcion.descripcion?.includes(texto)
          )
    )
  }

  const copiarImputacion = (categoria, value) => {
    props.copiar(categoria, value)
    props.copiar('imputacionTipo', props.item.imputacionTipo)
  }

  const obtenerPrecioUnitario = () => {
    const toNumber = (valor) => {
      const num = Number(valor)
      return Number.isFinite(num) ? num : 0
    }

    const tiersValidos = Array.isArray(props.item.preciosMayoristas)
      ? props.item.preciosMayoristas
          .map((p) => ({
            cantidad: toNumber(p.cantidad),
            precioUnitario: toNumber(p.precioUnitario)
          }))
          .filter((p) => p.cantidad > 0 && p.precioUnitario > 0)
      : []

    if (tiersValidos.length > 0) {
      const preciosOrdenados = [...tiersValidos].sort((a, b) => b.cantidad - a.cantidad)
      const precioMayorista = preciosOrdenados.find((p) => cantidad >= p.cantidad)
      if (precioMayorista) {
        return precioMayorista.precioUnitario
      }
    }

    const unitario = toNumber(props.item.precioUnitario)
    if (unitario > 0) {
      return unitario
    }

    const totalConIva = toNumber(props.item.valorTotalConIva)
    const cant = toNumber(cantidad) || 1
    return cant > 0 ? totalConIva / cant : 0
  }

  const esMayorista = () => {
    if (!props.item.preciosMayoristas || props.item.preciosMayoristas.length === 0) {
      return false
    }

    return props.item.preciosMayoristas.some((precioMayorista) => {
      const cantTier = Number(precioMayorista.cantidad)
      const precioTier = Number(precioMayorista.precioUnitario)
      return (
        Number.isFinite(cantTier) &&
        cantTier > 0 &&
        precioTier > 0 &&
        cantidad >= cantTier
      )
    })
  }

  return (
    <>
      <div
        className={`d-flex flex-wrap align-items-center mr-5 mb-3 ${styles.carritoItem}`}
      >
        <div className={`${styles.carritoRow} mb-5`}>
          <div className="text-center">
            <Imagen
              idPublicacion={props.item.idPublicacion}
              width={'100px'}
              height={'100px'}
            />
          </div>

          <div>
            <Button
              variant="link"
              onClick={() => navigate(`/Publicacion/${props.item.idPublicacion}`)}
            >
              {props.item.titulo}
            </Button>
          </div>

          <div className="d-flex align-items-center justify-content-center">
            <SumarProductos
              cantidad={cantidad}
              setCantidad={setCantidad}
              decrementar={restar}
              incrementar={sumar}
              cantDisponible={cantDisponible}
              agregarAlCarrito={null}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <Precios
              precio={obtenerPrecioUnitario()}
              monedaSimbolo={props.item.monedaSimbolo}
              alicuota={props.item.alicuota}
              cantidad={cantidad}
              showSinIVA={true}
              sufijo={esMayorista() ? '(mayorista)' : ''}
              className={styles['carritoitem__precios-item']}
            />
          </div>

          <div className="text-center">
            <Button
              variant="light"
              onClick={() => props.onDelete(props.item.idPublicacion)}
              className={styles.btnBackground}
            >
              <i className={`bi bi-trash-fill ${styles.btnIconColor}`}></i>
            </Button>
          </div>
        </div>
        <div
          className={`d-flex flex-wrap align-items-center ${styles.marginLeft} mb-2 ${styles.gapBloque2}`}
        >
          <InputConTextoSugerencia
            texto={'Código de material'}
            codigo={`codMat-${props.item.codigo}`}
            value={props.item.codMat || ''}
            copiar={props.copiar}
            setSugerencias={setSugerenciasCodMat}
            arrayChance={centroDeCostos?.catalogoMateriales}
            sugerencias={sugerenciasCodMat}
            categoria={'codMat'}
            handleSelectSugerencias={handleSelectSugerencias}
            handleChange={handleChange}
          />
          <InputConTextoSugerencia
            texto={'Planta'}
            codigo={`inputPlanta-${props.item.codigo}`}
            value={props.item.valorPlanta || ''}
            copiar={props.copiar}
            setSugerencias={setSugerencias}
            arrayChance={centroDeCostos?.usuariosPlantaEfectiva}
            sugerencias={sugerencias}
            categoria={'valorPlanta'}
            handleSelectSugerencias={handleSelectSugerencias}
            handleChange={handleChange}
          />

          <InputConTextoSugerencia
            texto={'Imputación'}
            codigo={`imputacion-${props.item.codigo}`}
            value={props.item.imputacionTipo || ''}
            copiar={props.copiar}
            arrayChance={centroDeCostos?.opcionesImputTpos}
            categoria={'imputacionTipo'}
            modificarCarrito={props.modificarCarrito}
            idPublicacion={props.item.idPublicacion}
          />

          {props.item.imputacionTipo && (
            <InputConTextoSugerencia
              texto={
                centroDeCostos?.opcionesImputTpos?.find(
                  (opcion) => opcion.value === props.item.imputacionTipo
                )?.label
              }
              codigo={`inputPlanta-${props.item.codigo}`}
              value={props.item.imputacionTipoOpcion || ''}
              copiar={copiarImputacion}
              setSugerencias={setSugerenciasImputacion}
              arrayChance={centroDeCostos?.listaImputaciones?.filter(
                (opcion) => opcion.value === props.item.imputacionTipo
              )}
              sugerencias={sugerenciasImputacion}
              categoria={'imputacionTipoOpcion'}
              handleSelectSugerencias={handleSelectSugerencias}
              handleChange={handleChange}
            />
          )}
        </div>
      </div>
      <hr />
    </>
  )
}

CarritoItem.propTypes = {
  centroDeCostos: PropTypes.object,
  item: PropTypes.shape({
    cantidad: PropTypes.number,
    cantDisponible: PropTypes.number,
    precioUnitario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    idPublicacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    valorTotalConIva: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    valorTotalSinIva: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    cantidadMayorista: PropTypes.number,
    monedaSimbolo: PropTypes.string,
    titulo: PropTypes.string,
    codMat: PropTypes.string,
    codigo: PropTypes.string,
    valorPlanta: PropTypes.string,
    imputacionTipo: PropTypes.string,
    imputacionTipoOpcion: PropTypes.string,
    alicuota: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    preciosMayoristas: PropTypes.array
  }).isRequired,
  sumar: PropTypes.func.isRequired,
  totalSuma: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setItems: PropTypes.func.isRequired,
  setTotalSuma: PropTypes.func.isRequired,
  modificarCarrito: PropTypes.func.isRequired,
  copiar: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

export default CarritoItem
